import React from 'react';
import {
  Add_new_bill,
  addPathToList,
  Choose_method,
  getSubCategoryId,
  Your_customer_can_click_new_bill,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================

const Panel_D01_PayBillsChooseMethod = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'add_new_bill',
    'scan_barcode',
    'type_the_barcode',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Add_new_bill}
      panelSubHeadline={Choose_method}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/select_bill/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/select_bill/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Your_customer_can_click_new_bill}
      language={language}
    />
  );
};

export default Panel_D01_PayBillsChooseMethod;
